import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from 'src/app/service/posts.service';

@Component({
  selector: 'app-view-post-details-by-user',
  templateUrl: './view-post-details-by-user.component.html',
  styleUrl: './view-post-details-by-user.component.scss'
})
export class ViewPostDetailsByUserComponent {

  details: any;
  id: any;
  otherDetails: any[] = [];

  playingVideoId: number | null = null;
  playClicked = false;

  private videoCache = new Map<number, SafeResourceUrl>();

  constructor(
    private postService: PostsService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

keywords:any;
  ngOnInit(): void {

    this.route.params.subscribe(params => {

      this.keywords = params['keywords'];

      // Main post details
      this.postService.getPostDetailsByKey(this.keywords)
        .subscribe(res => {

          this.details = res;
          this.id = this.details.id;
          if(Number(this.id)>0){
            this.getOther();
          }

         

        });


      

    });

  }

  getOther(){
    // Other post details
      this.postService.getPostOtherDetailsByUser(this.id)
        .subscribe(res => {

          this.otherDetails = res.sort(
            (a: {id:number}, b: {id:number}) => a.id - b.id
          );

          console.log(
            "otherDetails",
            this.otherDetails
          );

        });
  }


  // Click thumbnail and play video
  playVideo(id:number): void {

    this.playClicked = true;
    this.playingVideoId = id;

  }



  // Get iframe URL
  getCachedSafeUrl(id:number): SafeResourceUrl {


    if (this.videoCache.has(id)) {

      return this.videoCache.get(id)!;

    }


    const obj = this.otherDetails.find(
      x => x.id === id
    );


    if (!obj || !obj.videoUrl) {

      return this.sanitizer
        .bypassSecurityTrustResourceUrl('');

    }


    const videoId = this.extractYoutubeId(
      obj.videoUrl
    );


    if (!videoId) {

      return this.sanitizer
        .bypassSecurityTrustResourceUrl('');

    }


    const embedUrl =
      `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;


    const safeUrl =
      this.sanitizer
        .bypassSecurityTrustResourceUrl(embedUrl);


    this.videoCache.set(id, safeUrl);


    return safeUrl;

  }




  // Extract YouTube ID (Shorts, watch, embed, youtu.be)
  extractYoutubeId(url:string): string {


    if (!url) {

      return '';

    }


    const regex =
      /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([^?&\/]+)/;


    const match = url.match(regex);


    return match ? match[1] : '';

  }




  // Thumbnail
  getYoutubeThumbnail(url:string): string {


    const videoId =
      this.extractYoutubeId(url);


    if (!videoId) {

      return 'assets/images/no-video.png';

    }


    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  }



  // Optional direct iframe URL
  getSafeYoutubeUrl(url:string): SafeResourceUrl {


    const videoId =
      this.extractYoutubeId(url);


    return this.sanitizer
      .bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );

  }


}